// ================================================================
// Bottombar
// ================================================================

import './bottombar.css';
import { t } from '../../i18n/index.js';
import { icon } from '../../utils/dom.js';
import { state } from '../../core/state.js';
import { events, EVENTS } from '../../core/events.js';
import { runScenario } from '../../core/runner.js';
import { showLoading, showResult, showError } from '../run-panel/RunPanel.js';

let containerEl = null;

export function renderBottombar(container) {
  containerEl = container;
  draw();
  events.on(EVENTS.LANGUAGE_CHANGED, draw);
}

function draw() {
  containerEl.innerHTML = `
    <button class="bottombar-run" data-action="run">
      ${icon('play_arrow', 18)}
      ${t('bottombar.runOnce')}
    </button>

    <label class="bottombar-toggle">
      <input type="checkbox" />
      <span class="bottombar-toggle-slider"></span>
      <span class="bottombar-toggle-label">${t('bottombar.every15min')}</span>
    </label>

    <div class="bottombar-tools">
      <button class="bottombar-tool-btn" data-action="add" title="${t('bottombar.addNode')}">
        ${icon('add', 20)}
      </button>
      <button class="bottombar-tool-btn" data-action="undo" title="${t('bottombar.undo')}">
        ${icon('undo', 20)}
      </button>
      <button class="bottombar-tool-btn" data-action="align" title="${t('bottombar.align')}">
        ${icon('view_agenda', 20)}
      </button>
      <button class="bottombar-tool-btn" data-action="reset" title="${t('bottombar.reset')}">
        ${icon('refresh', 20)}
      </button>
    </div>
  `;

  containerEl.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-action]');
    if (!btn) return;
    const action = btn.dataset.action;

    if (action === 'add') {
      events.emit(EVENTS.MODAL_OPEN_PICKER, { fromNodeId: null });
    } else if (action === 'run') {
      handleRun(btn);
    } else if (action === 'reset') {
      state.reset();
    } else if (action === 'align') {
      state.nodes.forEach((n, i) => {
        state.moveNode(n.id, 200 + i * 180, 260);
      });
    }
  });
async function handleRun(btn) {
  btn.disabled = true;
  showLoading();
  try {
    const result = await runScenario();
    showResult(result);
  } catch (err) {
    console.error('Run failed:', err);
    showError(err.message || 'Fehler');
  } finally {
    btn.disabled = false;
  }
}
  
}
